import { JObject } from "../../../../../common/data/models";
import { PaginatedRequestParams, PaginatedResponse } from "../../../../../common/pagination";
import { StoreProductsRepository } from "../../data";
import { StoreProductDto, StoreProductSearchSimilarQuery } from "../dtos";
import { StockDto } from "../dtos/stock";

export class StoreProductsService {

    private readonly repository: StoreProductsRepository;

    constructor() {
        this.repository = new StoreProductsRepository();
    }

    public search(request: PaginatedRequestParams): Promise<PaginatedResponse<StoreProductDto>> {
        return this.repository.search(request);
    }
    public searchStock(request: PaginatedRequestParams): Promise<PaginatedResponse<StockDto>> {
        return this.repository.searchStock(request);
    }

    public searchSimilar(e: StoreProductSearchSimilarQuery): Promise<PaginatedResponse<StoreProductDto>> {
        return this.repository.searchSimilar(e);
    }
    public autoComplete(e: string): Promise<PaginatedResponse<string>> {
        return this.repository.autoComplete(e);
    }
    public searchSimilarWithPrice(e: StoreProductSearchSimilarQuery, request: PaginatedRequestParams): Promise<PaginatedResponse<StoreProductDto>> {
        return this.repository.searchSimilarWithPrice(e, request);
    }
    public updateProductQuantity(form: JObject): Promise<JObject> {
        return this.repository.updateProductQuantity(form);
    }

    public createOrUpdate(form: StoreProductDto): Promise<StoreProductDto> {
        return this.repository.createOrUpdate(form);
    }
    public updateQuantity(form: JObject): Promise<JObject> {
        return this.repository.updateQuantity(form);
    }

    public delete(id: number): Promise<boolean> {
        return this.repository.delete(id);
    }

    public deleteAll(ids: number[]): Promise<boolean> {
        return this.repository.deleteAll(ids);
    }

    public getDetails(id: number): Promise<StoreProductDto> {
        return this.repository.getDetails(id);
    }


    public activateAll(ids: StoreProductDto[]): Promise<boolean> {
        return this.repository.activateAll(ids);
    }

    public deactivateAll(ids: StoreProductDto[]): Promise<boolean> {
        return this.repository.deactivateAll(ids);
    }

}
